import React from 'react'

import styles from './styles/supplier_tricks_component.module.scss'
import { HtmlContent } from 'utils'
import MainSlide from './components/MainSlide'
import OptionalSlide from './components/OptionalSlide'

const SupplierTricksComponent = ({title, description, tricks}) => {
  return (
    <section className={styles.supplier_tricks_component}>
      <div className={styles.supplier_tricks_component__outer}>
        <h2 className={styles.supplier_tricks_component__title}>{title}</h2>
        <HtmlContent
          content={description} 
          className={styles.supplier_tricks_component__description} 
        />
      </div>

    <ul className={styles.supplier_tricks_component__list}>
      {tricks.map((item, i) => (
        <li key={i} className={styles.supplier_tricks_component__item_wrapper}>
          <MainSlide 
            title={item.title} 
            subtitle={item.subtitle}
            icon={item.icon}
            description={item.description}
          />

          <OptionalSlide
            content={item.first_slide_content}
            image={item.first_slide_image}
            label={item.first_slide_label}
          />

          <OptionalSlide
            content={item.second_slide_content}
            image={item.second_slide_image}
            label={item.second_slide_label}
          />
        </li>
      ))}
    </ul>

  </section>
  )
}

export default SupplierTricksComponent